if (typeof ProductForm !== 'function') {
	class ProductForm extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				form: 'form',
				cartDrawer: 'drawer-component[data-type="cart"]',
				drawer: 'drawer-component[data-type="drawer"]',
				submitButton: '[type="submit"]',
			};

			// Elements
			this.form = this.querySelector(this.selectors.form);
			this.cartDrawer = document.querySelector(this.selectors.cartDrawer);
			this.drawer = document.querySelector(this.selectors.drawer);
			this.submitButton = this.querySelector(this.selectors.submitButton);

			// Flags
			this.form.querySelector('[name=id]').disabled = false;
			if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
		}

		onSubmitHandler(evt) {
			evt.preventDefault();

			const { cartDrawer, drawer } = this;

			if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

			this.handleErrorMessage();

			this.submitButton.setAttribute('aria-disabled', true);
			this.submitButton.classList.add('button--loading');

			const config = fetchConfig('javascript');

			config.headers['X-Requested-With'] = 'XMLHttpRequest';

			delete config.headers['Content-Type'];

			const formData = new FormData(this.form);

			if (cartDrawer) {
				formData.append(
					'sections',
					cartDrawer.getSectionsToRender().map((section) => section.section)
				);
				formData.append('sections_url', window.location.pathname);
			}
			config.body = formData;

			fetch(`${window.routes.cart_add_url}.js`, config)
				.then((response) => response.json())
				.then((parsedState) => {
					if (parsedState.status) {
						this.handleErrorMessage(parsedState.description);

						this.submitButton.setAttribute('aria-disabled', true);
						this.submitButton.classList.add('button--loading');
						return;
					} else if (!this.cartDrawer) {
						window.location = window.routes.cart_url;

						return;
					}

					if (cartDrawer) {
						drawer.closeDrawer(false);
						cartDrawer.renderContents(parsedState);

						const imagesEvent = new CustomEvent('lazy-image:reload', {
							bubbles: true,
							detail: this,
						});

						document.dispatchEvent(imagesEvent);

						const cartEvent = new CustomEvent(THEME_EVENTS.cartUpdate, {
							bubbles: true,
							detail: {
								productVariantId: formData.get('id'),
								cart: parsedState,
							},
						});

						document.dispatchEvent(cartEvent);
					}
				})
				.catch((e) => {
					console.error(e);
				})
				.finally(() => {
					this.submitButton.classList.remove('button--loading');
					if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
					if (!this.error) this.submitButton.removeAttribute('aria-disabled');

					setTimeout(() => {
						trapFocus(cartDrawer);
					}, 100);
				});
		}

		handleErrorMessage(errorMessage = false) {
			this.errorMessageWrapper =
				this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

			if (!this.errorMessageWrapper) return;

			this.errorMessage =
				this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

			this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

			if (errorMessage) {
				if (typeof errorMessage === 'object') {
					this.errorMessage.innerHTML = ``;

					Object.keys(errorMessage).forEach((key) => {
						const spanError = document.createElement('span');
						spanError.innerHTML = key.concat(' ').concat(errorMessage[key]);
						this.errorMessage.appendChild(spanError);
					});
				} else {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	}

	if (!customElements.get('product-form')) {
		customElements.define('product-form', ProductForm);
	}
}

if (typeof VariantSelects !== 'function') {
	class VariantSelects extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				input: '.product-form__input',
			};

			this.init();
		}

		init() {
			this.addEventListeners();
		}

		addEventListeners() {
			this.addEventListener('change', (e) => {
				const inputGroupIndex = this.getInputGroupIndex(e);

				this.onVariantChange(inputGroupIndex);
			});
		}

		getInputGroupIndex(e) {
			const { selectors } = this;

			const inputGroup = e.target.closest(selectors.input);
			let inputGroupIndex = null;

			if (inputGroup.dataset.index !== undefined) {
				inputGroupIndex = +inputGroup.dataset.index;
			}

			return inputGroupIndex;
		}

		onVariantChange(inputGroupIndex) {
			this.updateOptions();
			this.updateMasterId();
			this.toggleAddButton(true, '', false);
			this.updatePickupAvailability();
			this.removeErrorMessage();
			this.updateVariantStatuses();

			if (!this.currentVariant) {
				this.toggleAddButton(true, '', true);
				this.setUnavailable();
			} else {
				this.updateURL();
				this.updateVariantInput();
				this.renderProductInfo(inputGroupIndex);
			}
		}

		updateOptions() {
			this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
		}

		updateMasterId() {
			this.currentVariant = this.getVariantData().find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		}

		updateURL() {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
			window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
		}

		updateVariantInput() {
			const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}`);

			productForms.forEach((productForm) => {
				const input = productForm.querySelector('input[name="id"]');

				input.value = this.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}

		updateVariantStatuses() {
			const selectedOptionOneVariants = this.variantData.filter(
				(variant) => this.querySelector(':checked').value === variant.option1
			);
			const inputWrappers = [...this.querySelectorAll('.product-form__input')];

			inputWrappers.forEach((option, index) => {
				if (!option.classList.contains('product-form__input--dropdown')) {
					this.updateLabel(option);
				}

				if (index === 0) return;
				const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
				const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
				const availableOptionInputsValue = selectedOptionOneVariants
					.filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
					.map((variantOption) => variantOption[`option${index + 1}`]);

				this.setInputAvailability(optionInputs, availableOptionInputsValue);
			});
		}

		updateLabel(option) {
			const label = option.querySelector('.form-label__selected-option');
			const selectedOption = option.querySelector(':checked').value;

			label.innerText = selectedOption;
		}

		setInputAvailability(listOfOptions, listOfAvailableOptions) {
			listOfOptions.forEach((input) => {
				if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
					input.innerText = input.getAttribute('value');
				} else {
					input.innerText = window.variantStrings.unavailable_with_option.replace(
						'[value]',
						input.getAttribute('value')
					);
				}
			});
		}

		updatePickupAvailability() {
			const pickUpAvailability = document.querySelector('pickup-availability');

			if (!pickUpAvailability) return;

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}

		removeErrorMessage() {
			const section = this.closest('section');

			if (!section) return;

			const productForm = section.querySelector('product-form');

			if (productForm) productForm.handleErrorMessage();
		}

		renderProductInfo(inputGroupIndex) {
			const requestedVariantId = this.currentVariant.id;
			const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

			fetch(
				`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
					this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
				}`
			)
				.then((response) => response.text())
				.then((responseText) => {
					// prevent unnecessary ui changes from abandoned selections
					if (this.currentVariant.id !== requestedVariantId) return;

					const html = new DOMParser().parseFromString(responseText, 'text/html');

					this.replaceImage(html);

					const destination = document.getElementById(`price-${this.dataset.section}`);
					const source = html.getElementById(
						`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
					);
					const skuSource = html.getElementById(
						`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
					);
					const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
					const inventorySource = html.getElementById(
						`Inventory-${
							this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
						}`
					);
					const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
					const labelsSource = html.getElementById(
						`Labels-${
							this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
						}`
					);
					const labelsDestination = document.getElementById(`Labels-${this.dataset.section}`);

					if (source && destination) destination.innerHTML = source.innerHTML;
					if (inventorySource && inventoryDestination)
						inventoryDestination.innerHTML = inventorySource.innerHTML;
					if (labelsSource && labelsDestination) labelsDestination.innerHTML = labelsSource.innerHTML;
					if (skuSource && skuDestination) {
						skuDestination.innerHTML = skuSource.innerHTML;
						skuDestination.classList.toggle(
							'visibility-hidden',
							skuSource.classList.contains('visibility-hidden')
						);
					}

					const price = document.getElementById(`price-${this.dataset.section}`);

					if (price) price.classList.remove('visibility-hidden');

					if (inventoryDestination)
						inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

					const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

					this.toggleAddButton(
						addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
						window.variantStrings.soldOut
					);

					const variantChangeEvent = new CustomEvent(THEME_EVENTS.variantChange, {
						bubbles: true,
						detail: {
							sectionId,
							html,
							variant: this.currentVariant,
							inputGroupIndex: inputGroupIndex,
						},
					});

					document.dispatchEvent(variantChangeEvent);
				});
		}

		toggleAddButton(disable = true, text, modifyClass = true) {
			const productForm = document.getElementById(`product-form-${this.dataset.section}`);

			if (!productForm) return;

			const addButton = productForm.querySelector('[name="add"]');

			if (!addButton) return;

			if (disable) {
				addButton.classList.add('button--disabled');
				addButton.setAttribute('disabled', 'disabled');
				if (text) addButton.textContent = text;
			} else {
				addButton.classList.remove('button--disabled');
				addButton.removeAttribute('disabled');
				addButton.textContent = window.variantStrings.addToCart;

				
				if(typeof preorderVariants !== 'undefined' && preorderVariants[this.currentVariant.id]) {
					const preorder = preorderVariants[this.currentVariant.id].preorder === 'true';
					
					if(preorder) {
						addButton.textContent = window.variantStrings.preorder;
					}
				}
			}

			if (!modifyClass) return;
		}

		replaceImage(html) {
			const imageSource = html.getElementById(
				`Image-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
			);
			const imageDestination = document.getElementById(`Image-${this.dataset.section}`);

			if (imageSource && imageDestination) {
				imageDestination.innerHTML = imageSource.innerHTML;

				const imagesReloadEvent = new CustomEvent('lazy-image:reload', {
					bubbles: true,
					detail: {
						container: imageDestination,
					},
				});

				document.dispatchEvent(imagesReloadEvent);
			}
		}

		setUnavailable() {
			const button = document.getElementById(`product-form-${this.dataset.section}`);
			const addButton = button.querySelector('[name="add"]');
			const price = document.getElementById(`price-${this.dataset.section}`);
			const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
			const sku = document.getElementById(`Sku-${this.dataset.section}`);

			if (!addButton) return;
			addButton.textContent = window.variantStrings.unavailable;
			if (price) price.classList.add('visibility-hidden');
			if (inventory) inventory.classList.add('visibility-hidden');
			if (sku) sku.classList.add('visibility-hidden');
		}

		getVariantData() {
			this.variantData =
				this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);

			return this.variantData;
		}
	}

	class VariantRadios extends VariantSelects {
		constructor() {
			super();
		}

		setInputAvailability(listOfOptions, listOfAvailableOptions) {
			listOfOptions.forEach((input) => {
				if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
					input.classList.remove('disabled');
				} else {
					input.classList.add('disabled');
				}
			});
		}

		updateOptions() {
			const fieldsets = Array.from(this.querySelectorAll('fieldset'));
			this.options = fieldsets.map((fieldset) => {
				return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
			});
		}
	}

	if (!customElements.get('variant-selects')) {
		customElements.define('variant-selects', VariantSelects);
	}

	if (!customElements.get('variant-radios')) {
		customElements.define('variant-radios', VariantRadios);
	}
}
